import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../EmptyFragment';
import Content from './Content';
import ToastReactions from './Reactions';
import ToastStore from './Store';

interface Props {
  store: ToastStore;
}

/**
 * The page's single toast slot, fixed at the bottom center. The live region
 * stays mounted so screen readers announce each toast as it appears.
 */
function Toast({ store }: Props) {
  const content = () => {
    switch (store.state.kind) {
      case 'hidden':
        return emptyFragment();
      case 'showing':
        return <Content store={store} toast={store.state.toast} />;
      default:
        return assertNever(store.state);
    }
  };

  return (
    <>
      <div
        role="status"
        aria-live="polite"
        className="pointer-events-none fixed bottom-6 left-1/2 flex -translate-x-1/2 justify-center"
        style={{ zIndex: 101 }}
      >
        {content()}
      </div>
      <ToastReactions store={store} />
    </>
  );
}

export default observer(Toast);
